import { useState } from "react";
import useValidFieldUpdate from "./useValidFieldUpdate.esm.js";
function useLastValidValues(form, getValues) {
  const [lastValidValues, setLastValidValues] = useState(() => getValues(form.getValues()));
  useValidFieldUpdate(form, (name, value) => setLastValidValues((prevLastValidValues) => getValues({
    ...prevLastValidValues.fields,
    [name]: value
  })));
  return lastValidValues;
}
export {
  useLastValidValues
};
